<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters class="justify-content-lg-start mb-1">
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="invoiceNumber"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">N° da nota fiscal</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="palletId"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">N° Pallet</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="invoiceIssuer"
                  v-mask="'NN.NNN.NNN/NNNN-NN'"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">CNPJ do Emissor da nota</label>
            </div>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="orderNumber"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">Pedido</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="volumeCode"
                  @keyup.enter="doFilter"
              />
              <label class="fl-label" style="left: 13px; right: 12px">Sku</label>
            </div>
          </b-col>
        </b-row>
        <b-row no-gutters class="justify-content-lg-start">
          <b-col sm="6" md="3" class="p-a-0 m-t-5px mr-1">
            <multiselect
                v-model="volumeOccurrenceFilterButton"
                track-by="value"
                label="label"
                id="volumeOccurrence"
                placeholder="Ocorrência"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :options="options.volumeOccurrence"
                :hide-selected="false"
            />
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <multiselect
                v-model="unitsFilterButton"
                track-by="value"
                label="label"
                id="units"
                select-label="Selecionar"
                placeholder="Unidades"
                tag-placeholder="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :options="options.units"
                :multiple="false"
                :hide-selected="false"
                :searchable="true"
            />
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <multiselect
                v-model="invoiceVolumeGroupStatusFilterButton"
                :options="options.invoiceVolumeGroupStatus"
                track-by="value"
                label="label"
                placeholder="Status"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                :hide-selected="false"
                selected-label="Selecionado"
                deselect-label="Remover"
            />
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px mr-1">
            <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder="Data de inclusão Inicial"
                v-model="invoiceInclusionDateStart"
                class="form-control"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                @keyup.enter="doFilter"
            />
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder="Data de inclusão Final"
                v-model="invoiceInclusionDateEnd"
                class="form-control"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                @keyup.enter="doFilter"
            />
          </b-col>
        </b-row>
        <b-row no-gutters class="justify-content-end">
          <b-col class="d-flex justify-content-end p-a-0 mt-1">
            <div class="input-group-btn">
              <div class="btn-group">
                <button type="button" class="btn btn-secondary btn-outline width-100" @click="doFilter"
                        :disabled="isFilterButtonDisabled">
                  Filtrar
                </button>
                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter">
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {InvoiceVolumeGroupStatusEnum, InvoiceVolumeStatusEnum} from "../enums/GeneralEnums";
import {formatDateSubmit, sanitizeAlphanumeric} from "../utils";

export default {
  components: {Multiselect},
  data() {
    return {
      invoiceNumber: "",
      palletId: "",
      orderNumber: "",
      volumeCode: "",
      invoiceInclusionDateStart: "",
      invoiceInclusionDateEnd: "",
      invoiceIssuer: "",
      units: [],
      volumeOccurrence: "",
      invoiceVolumeGroupStatus: "",
      perPage: 15,
      options: {
        units: [],
        volumeOccurrence: [],
        invoiceVolumeGroupStatus: this.getAllInvoiceVolumeGroupStatus(),
      },
      isLoading: {units: false, default: false},
      helpForm: new Form({params: [], search: "", status: 1}),
    };
  },
  mounted() {
    this.getAllVolumeOccurrence();
    this.getAllUnits();
  },
  methods: {
    doFilter() {
      if (!this.hasRequiredFilters()) {
        return this.showWarning("Informe ao menos um filtro para realizar a busca.");
      }

      const filterData = {
        invoiceNumber: this.invoiceNumber,
        palletId: this.palletId,
        orderNumber: this.orderNumber,
        volumeCode: this.volumeCode,
        invoiceInclusionDateStart: formatDateSubmit(this.invoiceInclusionDateStart),
        invoiceInclusionDateEnd: formatDateSubmit(this.invoiceInclusionDateEnd),
        invoiceIssuer: sanitizeAlphanumeric(this.invoiceIssuer),
        units: this.units.value,
        volumeOccurrence: this.volumeOccurrence.value,
        invoiceVolumeGroupStatus: this.invoiceVolumeGroupStatus.value,
      };
      this.$events.fire("filter-set", filterData);
    },
    resetFilter() {
      this.invoiceNumber = "";
      this.palletId = "";
      this.orderNumber = "";
      this.volumeCode = "";
      this.invoiceInclusionDateStart = "";
      this.invoiceInclusionDateEnd = "";
      this.invoiceIssuer = "";
      this.units = [];
      this.volumeOccurrence = "";
      this.invoiceVolumeGroupStatus = "";
      this.perPage = '';
      this.$events.fire("filter-reset");
    },
    getAllUnits(search) {
      this.isLoading.units = true;
      this.helpForm.search = search;
      this.helpForm
          .get("/api/unidade/jsonlist")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              this.options.units = response.items.map((item) => ({
                label: `${item.cd} - ${item.descr}`,
                value: item.unidade_id,
              }));
            }
            this.isLoading.units = false;
          })
          .catch((error) => {
            this.isLoading.units = false;
            new ReturnApi(error, this)
          });
    },
    getAllVolumeOccurrence() {
      this.helpForm
          .get("/api/inclusaoocorrencia/jsonlist")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            this.options.volumeOccurrence = response.param_ocorrencia.map((item) => ({
              label: `${item.cd} - ${item.descr}`,
              value: item.parocorren_id,
            }));
          })
          .catch((error) => new ReturnApi(error, this));
    },
    getAllInvoiceVolumeGroupStatus() {
      return [
        {label: "Em Separação", value: InvoiceVolumeGroupStatusEnum.IN_PROGRESS},
        {label: "Sem Agrupamento", value: InvoiceVolumeGroupStatusEnum.UNGROUPED},
      ];
    },
    showWarning(message) {
      this.$Simplert.open({
        title: "Atenção",
        message,
        customCloseBtnText: "Fechar",
        type: "warning",
      });
    },
    hasRequiredFilters() {
      return [
        this.invoiceNumber, this.palletId, this.orderNumber, this.volumeCode,
        this.invoiceInclusionDateStart, this.invoiceInclusionDateEnd,
        this.invoiceIssuer, this.units, this.volumeOccurrence, this.invoiceVolumeGroupStatus
      ].some(value => Array.isArray(value) ? value.length > 0 : !!value);
    },
    formattedLegalPersonLabel(item) {
      return `PJ - ${item.pessoa.cd} - ${item.razao_social} - ${this.formatDocument(
          item.cnpj_base,
          item.cnpj_filial,
          item.cnpj_digito
      )} - ${item.inscricao_estadual}`;
    },
    formatDocument(base, branch, digit) {
      const formattedBase = this.fillZerosToLength(base, 8);
      const formattedBranch = this.fillZerosToLength(branch, 4);
      const formattedDigit = this.fillZerosToLength(digit, 2);
      return `${formattedBase}${formattedBranch}${formattedDigit}`;
    },
    fillZerosToLength(value, length) {
      return value.toString().padStart(length, "0");
    },
  },
  computed: {
    invoiceVolumeGroupStatusFilterButton: {
      get() {
        return this.invoiceVolumeGroupStatus || []
      },
      set(value) {
        this.invoiceVolumeGroupStatus = value || []
      }
    },
    unitsFilterButton: {
      get() {
        return this.units || []
      },
      set(value) {
        this.units = value || []
      }
    },
    volumeOccurrenceFilterButton: {
      get() {
        return this.volumeOccurrence || []
      },
      set(value) {
        this.volumeOccurrence = value || []
      }
    },
    isFilterButtonDisabled() {
      return !this.hasRequiredFilters();
    },
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
